<template>
  <div class="nx-scrollytelling-slide-editor-wizard">
    <nx-scrollytelling-slide-title title="Bloques disponibles" />

    <template v-for="(templates, type, index) in templatesByType">
      <nx-form-scope-card :title="$t(`message.content.editor.scrollytelling.type.${type}`)"
                          :key="type"
                          :class="{
                            'mt-4': index === 0,
                            'mt-1': index > 0
                          }"
                          icon="web"
                          collapsable>
        <div class="nx-scrollytelling-slide-editor-wizard__list" :key="type">
          <v-flex v-for="template in templates"
                  :key="template.name"
                  shrink
                  class="nx-scrollytelling-slide-editor-wizard__item"
                  @click="handleCreate(template)"
          >
            <v-img class="nx-scrollytelling-slide-editor-wizard__image"
                   :src="template.image" :alt="template.name" width="172px"/>
          </v-flex>
        </div>
      </nx-form-scope-card>
    </template>
  </div>
</template>

<script>
import { availableSlideWizardTemplates, allowedOpeningSlideTypes } from '@/modules/scrollytelling/config';
import groupBy from 'lodash/groupBy';
import NxFormScopeCard from '@/modules/form/components/FormScopeCard';
import NxScrollytellingSlideTitle from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideTitle';

export default {
  name: 'nx-scrollytelling-slide-editor-wizard',
  components: { NxScrollytellingSlideTitle, NxFormScopeCard },
  props: {
    createOpening: {
      type: Boolean,
    },
  },
  computed: {
    templatesByType() {
      let templates = availableSlideWizardTemplates;
      if (this.createOpening) {
        templates = templates.filter(template => allowedOpeningSlideTypes.includes(template.type));
      }
      return groupBy(templates, 'type');
    },
  },
  methods: {
    handleCreate(template) {
      this.$emit('create', template);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/variables.styl'

.nx-scrollytelling-slide-editor-wizard {
  margin-top: 14px;

  &__title {
    font-family: Roboto
    font-size: 17px
    font-weight: 500
    font-stretch: normal
    font-style: normal
    line-height: 1.41
    letter-spacing: normal
    text-transform: uppercase
  }

  &__list {
    margin-right: 12px
    justify-content: space-between
    display: grid
    grid-template-columns: repeat(auto-fit, 180px)
    gap: 12px
  }

  &__item {
    display: flex
    cursor: pointer
    transition: transform 0.12s ease-in
    width: 180px
    height: 180px
    align-items: center;
    justify-content: center;

    &:hover {
      border-radius: 8px
      outline: 4px solid $secondary
      > * {
        opacity: 0.5
      }
    }
  }
}
</style>
